import type { PixelAccessor } from "../pixel-accessor";
import type { Color } from "../types";
import type { ColorInterpolator } from "./ColorInterpolator";

/**
 * No interpolation -- just returns single pixel color.
 */
export class IntegerInterpolator implements ColorInterpolator {
  /**
   * @inheritDoc
   */
  interpolate(image: PixelAccessor, x: number, y: number): Color {
    return image.getPixelColor(Math.floor(x), Math.floor(y));
  }
}
